<template>
  <div class="partner">
    <div class="container">
      <com-title title="合作伙伴" subtitle="部分合作伙伴"></com-title>
      <ul class="content columns is-mobile">
        <li v-for="(item, index) in partners" :key="index" class="column is-one-fifth-tablet is-half-mobile">
          <a :href="item.link" target="_blank">
            <div class="img">
              <img :src="item.avatar">
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import comTitle from '@/base/title'
export default {
  data () {
    return {}
  },
  components: {
    comTitle
  },
  props: ['partners'],
  computed: {}
}
</script>
<style scoped lang='sass'>
@import '../style/variable.sass'

+mobile
  .container
    width: 88vw

div.partner
  background-color: #fff
  padding-bottom: 80px

  ul
    flex-wrap: wrap
    li
      a
        display: flex
        justify-content: center
        align-items: center
        margin: 0 auto
        background-color: #fff
        box-shadow: 0px 4px 15px 0px rgba(7, 17, 27, 0.1)
        .img
          width: 158px
          height: 98px
          display: flex
          justify-content: center
          align-items: center
          img
            width: 100%
            +mobile
              width: 140px
</style>
